export const LaCon = 'https://api-colsan.doevidas.com.br/'//'http://192.168.0.2:8000/';//
export const SelfLink = 'https://colsan.doevidas.com.br/';
export const Passport = '4nADT6SHdCZ3VsmOFakUrzBkdFZSqGZ0OVbSEE27';